import { render } from "./BirthdaysList.vue?vue&type=template&id=1f75e725"
import script from "./BirthdaysList.vue?vue&type=script&lang=js"
export * from "./BirthdaysList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__